import { Component, OnInit, OnDestroy, NgZone, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// import { BackendApiService } from '../../../services/backend-api.service';
// import { BaseUrlConstantsService } from '../../../services/base-url-constants.service';
import { reduce, retry } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'app-device-detail',
  templateUrl: './device-detail.component.html',
  styleUrls: ['./device-detail.component.scss']
})
export class DeviceDetailComponent implements OnInit, OnDestroy {

  constructor(){

  }

  ngOnDestroy(){

  }

  ngOnInit(){

  }

  // @ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective;
  // public sensorData = BaseUrlConstantsService.Sensor_Data;
  // public accelsensorData = BaseUrlConstantsService.Accel_Sensor_Data;
  // public Fft_List = BaseUrlConstantsService.FFT_LIST;
  // public lineChartData: ChartDataSets[] = [];
  // public filterType: any;
  // public abc = false;
  // public lineChartDataTemp: ChartDataSets[] = [];
  // public lineChartDataOrientation: ChartDataSets[] = [];
  // public lineChartLabels: Label[] = [];
  // public lineChartLabelsOrientation: Label[] = [];
  // public lineChartLabelsTemp: Label[] = [];
  // public showlineChart1: boolean;
  // applicationNme: any;
  // public _status: any;
  // public _offlineStatus: any;
  // public _lastUpdate: any;
  // public _devStaus: any;
  // public _orientationX: any;
  // public _orientationY: any;
  // public _orientationZ: any;
  // public _interval: any = 30000;//30seconds
  // fday: boolean;
  // fweek: boolean;
  // fmonth: boolean;
  // fmonths: boolean;
  // public data: any = [];
  // public columnNames: any = [];

  // public highchartOptions: any = {};



  // testArr = [];
  // showlineChart3: any;
  // errorMSG = '';
  // public lineChartOptions: (ChartOptions & { annotation: any }) = {
  //   legend: {
  //     position: 'top',
  //     display: true,
  //     labels: {
  //       fontSize: 14,
  //       boxWidth: 0,
  //       usePointStyle: true
  //     }
  //   },
  //   responsive: true,
  //   scales: {
  //     xAxes: [{
  //       id: 'X-axis-0',
  //       position: 'bottom',
  //       gridLines: {
  //         display: false
  //       }
  //     }],
  //     yAxes: [
  //       {
  //         id: 'y-axis-0', position: 'left', ticks: {}, gridLines: {
  //           display: false
  //         }
  //       }
  //     ]
  //   },
  //   annotation: {
  //     drawTime: 'beforeDatasetsDraw',
  //     annotations: [
  //       {
  //         type: 'box',
  //         id: 'y-axis-box',
  //         mode: 'horizontal',
  //         yScaleID: 'y-axis-0',
  //         backgroundColor: 'rgba(252, 175, 175, 0.26)',
  //         borderWidth: 0
  //       },
  //       {
  //         type: 'box',
  //         id: 'y-axis-1',
  //         mode: 'horizontal',
  //         yScaleID: 'y-axis-0',
  //         backgroundColor: '#ffec8b63',
  //         borderWidth: 0
  //       },
  //       {
  //         type: 'box',
  //         id: 'y-axis-2',
  //         mode: 'horizontal',
  //         yScaleID: 'y-axis-0',
  //         backgroundColor: '#7befb263',
  //         borderWidth: 0
  //       },
  //     ]
  //   },
  // };




  // public lineChartOptionsTemp: (ChartOptions & { annotation: any }) = {
  //   legend: {
  //     position: 'top',
  //     display: true,
  //     labels: {
  //       fontSize: 14,
  //       boxWidth: 0,
  //       usePointStyle: true
  //     }
  //   },
  //   responsive: true,
  //   scales: {
  //     xAxes: [{
  //       id: 'X-axis-0',
  //       position: 'bottom',
  //       gridLines: {
  //         display: false
  //       }
  //     }],
  //     yAxes: [
  //       {
  //         id: 'y-axis-0', position: 'left', gridLines: {
  //           display: false
  //         }, ticks: {}
  //       }
  //     ]
  //   },
  //   annotation: {
  //     drawTime: 'beforeDatasetsDraw',
  //     annotations: [
  //       {
  //         type: 'box',
  //         id: 'y-axis-box1',
  //         mode: 'horizontal',
  //         yScaleID: 'y-axis-0',
  //         backgroundColor: 'rgba(252, 175, 175, 0.26)',
  //         borderWidth: 0
  //       },
  //       {
  //         type: 'box',
  //         id: 'y-axis-3',
  //         mode: 'horizontal',
  //         yScaleID: 'y-axis-0',
  //         backgroundColor: '#ffec8b63',
  //         borderWidth: 0
  //       },
  //       {
  //         type: 'box',
  //         id: 'y-axis-4',
  //         mode: 'horizontal',
  //         yScaleID: 'y-axis-0',
  //         backgroundColor: '#7befb263',
  //         borderWidth: 0
  //       },
  //     ]
  //   },
  // };
  // public lineChartColors: Color[] = [
  //   {
  //     backgroundColor: 'transparent',
  //     borderColor: 'rgb(0,250,154)',
  //     pointBackgroundColor: '',
  //     pointBorderColor: '',
  //     pointHoverBackgroundColor: '',
  //     pointHoverBorderColor: '',
  //   },
  //   {
  //     backgroundColor: 'transparent',
  //     borderColor: 'rgb(255,165,0)',
  //     pointBackgroundColor: 'rgba(77,83,96,1)',
  //     pointBorderColor: '#fff',
  //     pointHoverBackgroundColor: '',
  //     pointHoverBorderColor: ''
  //   },
  //   {
  //     backgroundColor: 'transparent',
  //     borderColor: 'rgb(240,128,128)',
  //     pointBackgroundColor: 'rgba(148,159,177,1)',
  //     pointBorderColor: '#fff',
  //     pointHoverBackgroundColor: '',
  //     pointHoverBorderColor: ''
  //   }
  // ];



  // public lineChartOptionsOrientation: (ChartOptions & { annotation: any }) = {
  //   legend: {
  //     position: 'top',
  //     display: true,
  //     labels: {
  //       fontSize: 14,
  //       boxWidth: 0,
  //       usePointStyle: true
  //     }
  //   },
  //   responsive: true,
  //   scales: {
  //     xAxes: [{
  //       id: 'X-axis-0',
  //       position: 'bottom',
  //       gridLines: {
  //         display: false
  //       }
  //     }],
  //     yAxes: [
  //       {
  //         id: 'y-axis-0', position: 'left', ticks: { stepSize: 20 }, gridLines: {
  //           display: false
  //         }
  //       }
  //     ]
  //   },
  //   annotation: {
  //     drawTime: 'beforeDatasetsDraw',
  //     annotations: [
  //       {
  //         type: 'box',
  //         id: 'y-axis-box',
  //         mode: 'horizontal',
  //         yScaleID: 'y-axis-0',
  //         backgroundColor: 'rgba(252, 175, 175, 0.26)',
  //         borderWidth: 0
  //       },
  //       {
  //         type: 'box',
  //         id: 'y-axis-1',
  //         mode: 'horizontal',
  //         yScaleID: 'y-axis-0',
  //         backgroundColor: '#ffec8b63',
  //         borderWidth: 0
  //       },
  //       {
  //         type: 'box',
  //         id: 'y-axis-2',
  //         mode: 'horizontal',
  //         yScaleID: 'y-axis-0',
  //         backgroundColor: '#7befb263',
  //         borderWidth: 0
  //       },
  //     ]
  //   },
  // };

  // showlineChart2: boolean;
  // public lineChartLegend = true;
  // public lineChartType = 'line';
  // public lineChartPlugins = [pluginAnnotations];
  // public SystemName = 'MF1';
  // public firstCopy = false;
  // public canvasWidth = 150;
  // public needleValue = 20;
  // public centralLabel = '';
  // public name = 'N/A';
  // public bottomLabel = 'N/A';

  // public breadcrumbsArray: any = [{
  //   page_ref: 'device-reports',
  //   page_title: 'Assets'
  // }, {
  //   page_ref: '#',
  //   page_title: 'Trend Analysis'
  // }];
  // public Itemsymbol: any;
  // public pageRef: any;
  // public dataGadge: any;
  // public meterShownResult: any = [];
  // public tempratueResults: any = [];
  // public orientationData: any = [];
  // public rateOfTemp: any = [];
  // public rateOfChange: any = [];
  // public nameDevice: any;
  // public deviceId: any;
  // public errorStatus: any;
  // public deviceStatus: any;
  // public addclass: any;
  // valueSelected: any;
  // // tslint:disable-next-line: variable-name
  // public _deviceInfo: any;
  // public daterangeForm: any;
  // chartBoxVisibility = false;
  // chartBoxVisibility1 = false;
  // public pageName: string;
  // public showGraph: any = 0;
  // public assetId: any;
  // public _lstUpdateDate: any;
  // tabColor = '1day';
  // dayValue = 24;
  // weekValue: number;
  // monthValue: number;
  // valueType = 'min';
  // selectValue = null;
  // btnColour = '#dedede';
  // btnColor2 = '#ffffff';
  // siteName: any;
  // appMacAdd: any;
  // serialNumber: any;
  // _timeOut: any;
  // public trendAnalysData: any = [];

  // public title;
  // public type;
  // public ddata: any = [];
  // public options: any = {};
  // public width;
  // public height;
  // public dataChart = [];
  // constructor(
  //   public router: Router,
  //   public activeRoute: ActivatedRoute,
  //   public service: BackendApiService,
  //   private formBuilder: FormBuilder) {
  //   activeRoute.queryParams.subscribe(params => {
  //     this.deviceId = params[`deviceId`];
  //     this.assetId = params[`assetid`];
  //     this.nameDevice = params[`deviceName`];
  //     this.errorStatus = params[`errorStatus`];
  //     this.deviceStatus = params[`deviceStatus`];
  //     this.pageName = params[`pageRef`];
  //     if (this.pageName === 'managerAssets') {
  //       const myObj = {
  //         page_ref: 'manager-client-list',
  //         page_title: 'manager clients'
  //       };
  //       this.breadcrumbsArray.unshift(myObj);
  //     }
  //   });
  // }


  // selectItem(value) {
  //   localStorage.setItem('dataInterval', value);
  //   switch (value) {
  //     case '1day':
  //       this.selectValue = 24;
  //       this.valueType = 'min';
  //       this.loadAllGraphs();
  //       this.tabColor = value;
  //       break;
  //     case '1week':
  //       this.selectValue = 24;
  //       this.valueType = 'hour';
  //       this.loadAllGraphs();
  //       this.tabColor = value;
  //       break;
  //     case '1month':
  //       this.selectValue = 24;
  //       this.valueType = 'days';
  //       this.loadAllGraphs();
  //       this.tabColor = value;
  //       break;
  //     case '3month':
  //       this.selectValue = 24;
  //       this.valueType = 'days';
  //       this.loadAllGraphs();
  //       this.tabColor = value;
  //       break;
  //   }
  // }

  // loadAllGraphs() {
  //   if (this._timeOut !== undefined) {
  //     clearTimeout(this._timeOut);
  //   }
  //   let dataFreq = parseInt(localStorage.getItem('dataFrq'))
  //   dataFreq = ((dataFreq * 60) * 1000) - parseInt(this._interval);
  //   this.getSensorCharts('graph');
  //   this.getSensorTempCharts('graph');
  //   this.getSensorOrientationCharts('graph');
  //   let self = this;
  //   self._timeOut = setInterval(function () {
  //     self.getGaugeDataByID();
  //     this.showlineChart1 = true;
  //     //self.getSensorCharts('interval');
  //     self.getSensorTempCharts('interval');
  //     self.getSensorOrientationCharts('interval');
  //   }, dataFreq);
  // }


  // async getGaugeDataByID() {
  //   let response: any;
  //   const body = {
  //     deviceid: parseInt(this.deviceId),
  //     assetid: parseInt(this.assetId),
  //     // tslint:disable-next-line: radix
  //     datafrequency: parseInt(localStorage.getItem('dataFrq'))
  //   };
  //   this.service.postData(this.sensorData, body).then(res => {

  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (response.status === 'fail') {
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       if (response.body.issue.lastupdate !== this._lstUpdateDate) {
  //         this.rateOfChange = [];
  //         this.tempratueResults = [];
  //         this.meterShownResult = [];
  //         this._lstUpdateDate = response.body.issue.lastupdate;
  //         let newDate = response.body.issue.lastupdate.split('T');
  //         let splitedDate = newDate[0] + ' ' + newDate[1].substring(0, 8);

  //         this._lastUpdate = splitedDate + ' (IST)';//new Date(response.body.issue.lastupdate).toLocaleString()//splitedDate;
  //         this._status = response.body.issue.status;
  //         this._offlineStatus = response.body.issue.offlinestatus;
  //         if (this._status === 'Offline') {
  //           this._devStaus = 'Last';
  //         } else {
  //           this._devStaus = 'Latest';
  //         }
  //         this.filterType = response.body.issue.filterType;
  //         let _timeInterval = localStorage.getItem('dataInterval');
  //         if (_timeInterval === 'null') {
  //           if (this.filterType === 'month') {
  //             this.fday = true;
  //             this.fweek = true;
  //             this.fmonth = false;
  //             this.fmonths = false;
  //             this.selectItem('1month');
  //           } else if (this.filterType === 'months') {
  //             this.fday = true;
  //             this.fweek = true;
  //             this.fmonth = true;
  //             this.fmonths = false;
  //             this.selectItem('3month');
  //           } else if (this.filterType === 'week') {
  //             this.fday = true;
  //             this.fweek = false;
  //             this.fmonth = false;
  //             this.fmonths = false;
  //             this.selectItem('1week');
  //           } else if (this.filterType === 'day') {
  //             this.fday = false;
  //             this.fweek = false;
  //             this.fmonth = false;
  //             this.fmonths = false;
  //             this.selectItem('1day');
  //           }
  //         }
  //         if (response.body.sensor === 'No results found') {
  //           this.showGraph = 0;
  //           this.errorMSG = response.body.sensor;
  //         } else {
  //           this.dataGadge = response.body.sensor;
  //           let bottomLab;
  //           if (this.dataGadge.length !== 0) {
  //             this.showGraph = 1;
  //             // tslint:disable-next-line: prefer-for-of
  //             for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
  //               if (JSON.parse(this.dataGadge[mCount].value) === 0 && this.dataGadge[mCount].needle === false) {
  //                 bottomLab = 'N/A';
  //               } else {
  //                 bottomLab = JSON.parse(this.dataGadge[mCount].value) <= 0 ? 'N/A' : (this.dataGadge[mCount].symbol === 'C' ? JSON.parse(this.dataGadge[mCount].value) + ' °' + this.dataGadge[mCount].icon : JSON.parse(this.dataGadge[mCount].value) + ' ' + this.dataGadge[mCount].icon); // this.dataGadge[mCount].symbol === 'C' ?
  //                 //this.dataGadge[mCount].value <= 0 ? 'N/A' :
  //                 // this.dataGadge[mCount].value + ' °' + this.dataGadge[mCount].icon :
  //                 // JSON.parse(this.dataGadge[mCount].value) + ' ' + this.dataGadge[mCount].icon;
  //               }
  //               // tslint:disable-next-line: radix
  //               if (parseInt(this.dataGadge[mCount].needle) === 0) {
  //                 this.addclass = 'big_font_chartbox';
  //               } else {
  //                 this.addclass = '';
  //               }
  //               this.Itemsymbol = this.dataGadge[mCount].symbol;
  //               const accelerationData = {
  //                 needleValue: this.dataGadge[mCount].symbol === 'm/sec²' ? JSON.parse(this.dataGadge[mCount].value) * 100 / parseFloat(this.dataGadge[mCount].rangelabel[1]) : JSON.parse(this.dataGadge[mCount].value), //this.dataGadge[mCount].symbol === 'C' ?
  //                 //JSON.parse(this.dataGadge[mCount].value) * 100 / 120 : (this.dataGadge[mCount].symbol === 'deg' ? JSON.parse(this.dataGadge[mCount].value) : JSON.parse(this.dataGadge[mCount].value) * 100 / parseInt(this.dataGadge[mCount].rangelabel[1])),
  //                 centralLabel: JSON.parse(this.dataGadge[mCount].value) < 0 ?
  //                   'N/A' : JSON.parse(this.dataGadge[mCount].value),
  //                 outerNeedle: false,
  //                 canvasWidth: 150,
  //                 name: this.dataGadge[mCount].name,
  //                 bottomLabel: bottomLab,
  //                 hasneedle: this.dataGadge[mCount].needle,
  //                 options: {
  //                   hasNeedle: this.dataGadge[mCount].needle,
  //                   needleColor: 'black',
  //                   needleUpdateSpeed: '',
  //                   arcColors: this.dataGadge[mCount].needle === true ?
  //                     this.dataGadge[mCount].arcColors : [
  //                       'transparent',
  //                       'transparent',
  //                       'transparent'],
  //                   arcDelimiters: this.dataGadge[mCount].arcDelimiters,
  //                   rangeLabel: this.dataGadge[mCount].needle === true ? this.dataGadge[mCount].rangelabel : [],
  //                   needleStartValue: 0
  //                 }
  //               };

  //               if (accelerationData.name === 'RMS Vibration 1 (X Axis)') {
  //                 this.meterShownResult.splice(0, 0, accelerationData);
  //               }
  //               if (accelerationData.name === 'RMS Vibration 1 (Y Axis)') {
  //                 this.meterShownResult.splice(1, 0, accelerationData);
  //               }
  //               if (accelerationData.name === 'RMS Vibration 1 (Z Axis)') {
  //                 this.meterShownResult.splice(2, 0, accelerationData);
  //               }
  //               if (accelerationData.name !== 'RMS Vibration 1 (X Axis)'
  //                 && accelerationData.name !== 'RMS Vibration 1 (Y Axis)'
  //                 && accelerationData.name !== 'RMS Vibration 1 (Z Axis)'
  //                 && accelerationData.name !== 'Rate of change of orientation'
  //                 && accelerationData.name !== 'Rate of change of Orientation X'
  //                 && accelerationData.name !== 'Rate of change of Orientation Y'
  //                 && accelerationData.name !== 'Rate of change of Orientation Z'
  //                 && accelerationData.name !== 'Drive Side Bearing Temp.'
  //                 && accelerationData.name !== 'Stator Winding Temp.'
  //                 && accelerationData.name !== 'Ambient Temp.'
  //                 && accelerationData.name !== 'Rate of change of useful life left') {
  //                 this.meterShownResult.push(accelerationData);
  //               }
  //               if (accelerationData.name === 'Drive Side Bearing Temp.'
  //                 || accelerationData.name === 'Stator Winding Temp.'
  //                 || accelerationData.name === 'Ambient Temp.') {
  //                 this.tempratueResults.push(accelerationData);
  //               }
  //               if (accelerationData.name === 'Rate of change of useful life left') {
  //                 this.rateOfChange.push(accelerationData);
  //               }

  //               if (accelerationData.name === 'Rate of change of Orientation X') {
  //                 this._orientationX = accelerationData.needleValue;
  //               }
  //               if (accelerationData.name === 'Rate of change of Orientation Y') {
  //                 this._orientationY = accelerationData.needleValue;
  //               }
  //               if (accelerationData.name === 'Rate of change of Orientation Z') {
  //                 this._orientationZ = accelerationData.needleValue;
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   });
  // }


  // async goToPageLink(name: string) {
  //   const navigationExtras = {
  //     skipLocationChange: true,
  //     queryParams: {
  //       pageRef: 'managerAssets' === this.pageName ? 'managerAssets' : ''
  //     }
  //   };
  //   this.router.navigate([name], navigationExtras);
  // }



  // ngOnInit() {
  //   localStorage.setItem('dataInterval', null);
  //   this.siteName = localStorage.getItem('siteName');
  //   this.appMacAdd = localStorage.getItem('appMacAdd');
  //   this.serialNumber = localStorage.getItem('serialNumber');
  //   this.applicationNme = localStorage.getItem('applicationName');
  //   this.getGaugeDataByID();
  //   this.getFftList();
  // }

  // ngOnDestroy() {
  //   if (this._timeOut !== undefined) {
  //     clearInterval(this._timeOut);
  //   }
  // }
  // async getSensorCharts(_satus) {
  //   const SesnsorMaxVals = [];
  //   if (_satus !== "interval") {
  //     this.showlineChart1 = false;
  //   }
  //   let response: any;

  //   const body = {
  //     deviceid: parseInt(this.deviceId),
  //     assetid: parseInt(this.assetId),
  //     sensorinterval: this.selectValue === null ? 24 : this.selectValue,
  //     sensordetailtype: this.valueType,
  //     sensorids: [6, 7, 8],
  //     // tslint:disable-next-line: radix
  //     //datafrequency: parseInt(localStorage.getItem('dataFrq'))
  //   };
  //   this.service.postData(this.accelsensorData, body).then(res => {
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       if (response.body.message === 'No results found') {
  //         this._status = response.body.status;
  //         this._offlineStatus = response.body.offlinestatus;
  //         if (this._status === 'Offline') {
  //           this._devStaus = 'Last';
  //         } else {
  //           this._devStaus = 'Latest';
  //         }
  //         this.showlineChart1 = false;
  //       } else {
  //         let thresholdVals = [];
  //         thresholdVals = response.body.threshold;
  //         const xArrVal = [];
  //         if (response.body.chartdata !== 0) {
  //           this.showlineChart1 = true;
  //           let newArray = response.body.chartdata.map((currentValue) => {
  //             if (currentValue[0] !== "time") {
  //               currentValue[0] = new Date(currentValue[0]);

  //               return currentValue;
  //             }
  //             else {
  //               return currentValue;
  //             }
  //           });

  //           let data: any = google.visualization.arrayToDataTable(newArray);

  //           let options = {
  //             chart: { trendlines: { 0: { color: 'black' }, 1: { color: 'yellow' }, 2: { color: 'brown' } } },
  //             displayAnnotations: true,
  //             chartarea: {
  //               width: '90%',
  //               height: '90%'
  //             },
  //             displayLegendValues: true,
  //             displayZoomButtons: false,
  //             allValuesSuffix:'m/sec²'
  //           }
  //           var chart = new google.visualization.AnnotationChart(document.getElementById('sensor_div'));
  //           chart.draw(data, options);


  //           // tslint:disable-next-line: prefer-for-of

  //           //const trandArrData = xArrVal;
  //           //for (let dataMe = 0; dataMe < response.body.chartdata.length; dataMe++) {
  //           //  if (response.body.chartdata[dataMe].label === 'RMS Vibration 1 (X Axis)') {
  //           //    xArrVal.splice(0, 0, {
  //           //      name: response.body.chartdata[dataMe].label, data: response.body.chartdata[dataMe].data.map(function (v) { return +v }), marker: {
  //           //        enabled: true,
  //           //        radius: 2
  //           //      },
  //           //      regression: true,
  //           //      regressionSettings: {
  //           //        type: 'linear',
  //           //        color: 'rgba(223, 83, 83, .9)'
  //           //      },
  //           //    });
  //           //  } else if (response.body.chartdata[dataMe].label === 'RMS Vibration 1 (Y Axis)') {
  //           //    xArrVal.splice(1, 0, {
  //           //      name: response.body.chartdata[dataMe].label, data: response.body.chartdata[dataMe].data.map(function (v) { return +v }), marker: {
  //           //        enabled: true,
  //           //        radius: 2
  //           //      },
  //           //      regression: true,
  //           //      regressionSettings: {
  //           //        type: 'linear',
  //           //        color: '#0000FF'
  //           //      },
  //           //    });
  //           //  } else if (response.body.chartdata[dataMe].label === 'RMS Vibration 1 (Z Axis)') {
  //           //    xArrVal.splice(2, 0, {
  //           //      name: response.body.chartdata[dataMe].label, data: response.body.chartdata[dataMe].data.map(function (v) { return +v }), marker: {
  //           //        enabled: true,
  //           //        radius: 2
  //           //      },
  //           //      regression: true,
  //           //      regressionSettings: {
  //           //        type: 'linear',
  //           //        color: '#008080'
  //           //      },
  //           //    });
  //           //  }
  //           //}


  //           //for (let i = 0; i < response.body.chartdata.length; i++) {
  //           //  const maxVal = response.body.chartdata[i].data.reduce((a, b) => Math.max(a, b));
  //           //  SesnsorMaxVals.push(maxVal);
  //           //}
  //           //const _maxVal = SesnsorMaxVals.reduce((a, b) => Math.max(a, b));
  //           //if (response.body.frequency.length > this.lineChartLabels.length && _satus === "interval") {
  //           //  //this.highchartOptions = this.setChartProperties(response.body.frequency, trandArrData, Math.max(_maxVal, thresholdVals[2]), thresholdVals, 'm/sec²');
  //           //  //this.lineChartData = trandArrData;
  //           //  //this.lineChartLabels = response.body.frequency;
  //           //} else if (_satus !== "interval") {
  //           //  // this.highchartOptions = this.setChartProperties(response.body.frequency, trandArrData, Math.max(_maxVal, thresholdVals[2]), thresholdVals, 'm/sec²');
  //           //}

  //         }

  //         //// tslint:disable-next-line: prefer-for-of

  //         //// tslint:disable-next-line: variable-name
  //         //this.lineChartOptions.annotation.annotations[0].yMin = thresholdVals[1];
  //         //this.lineChartOptions.annotation.annotations[0].yMax = thresholdVals[2];

  //         //this.lineChartOptions.annotation.annotations[1].yMin = thresholdVals[0];
  //         //this.lineChartOptions.annotation.annotations[1].yMax = thresholdVals[1];

  //         //this.lineChartOptions.annotation.annotations[2].yMin = 0;
  //         //this.lineChartOptions.annotation.annotations[2].yMax = thresholdVals[0];

  //         //const _maxVal = SesnsorMaxVals.reduce((a, b) => Math.max(a, b));

  //         //this.lineChartOptions.scales.yAxes[0].ticks.max = Math.max(_maxVal, thresholdVals[2]);
  //         //this.lineChartOptions.annotation.annotations[0].yMax = Math.max(_maxVal, thresholdVals[2]);


  //       }
  //     }
  //   });
  // }


  // getFftList() {
  //   let self = this;
  //   let response: any;
  //   const body = {
  //     deviceid: this.deviceId,
  //     assetid: this.assetId
  //   };
  //   this.service.postData(this.Fft_List, body).then(res => {
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       this.trendAnalysData = response.body;
  //     }
  //   });
  // }

  // loadFftData(value) {
  //   let _timeFft = this.trendAnalysData.filter(v => v.value === value)[0].label;
  //   const navigationExtras = {
  //     skipLocationChange: true,
  //     queryParams: {
  //       fftTime: value,
  //       fftDataTime: _timeFft,
  //       nameDevice: this.nameDevice,
  //       errorStatus: this.errorStatus,
  //       deviceStatus: this.deviceStatus,
  //       deviceID: this.deviceId,
  //       assetid: this.assetId,
  //       onOffStatus: this._status,
  //       deviceCurrentStatus: this._devStaus,
  //       sinceDate: this._offlineStatus,
  //       lastUpdate: this._lastUpdate
  //     }
  //   };
  //   this.router.navigate(['deep-link-detail/'], navigationExtras);
  // }


  // async getSensorTempCharts(_satus) {
  //   const sensorTempMaxVals = [];
  //   if (_satus !== "interval") {
  //     this.showlineChart2 = false;
  //   }
  //   let response: any;
  //   const body = {
  //     deviceid: this.deviceId,
  //     assetid: parseInt(this.assetId),
  //     sensorinterval: this.selectValue === null ? 24 : this.selectValue,
  //     sensordetailtype: this.valueType,
  //     sensorids: [1, 2, 3],
  //     // tslint:disable-next-line: radix
  //     //datafrequency: parseInt(localStorage.getItem('dataFrq'))
  //   };
  //   this.service.postData(this.accelsensorData, body).then(res => {
  //     //this.showlineChart2 = true;
  //     this.chartBoxVisibility = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       if (response.body.message === 'No results found') {
  //         this.showlineChart2 = false;
  //       } else {
  //         let thresholdVals = [];
  //         thresholdVals = response.body.threshold;
  //         if (response.body.chartdata !== 0) {
  //           this.showlineChart2 = true;
  //           let newArray = response.body.chartdata.map((currentValue) => {
  //             if (currentValue[0] !== "time") {
  //               currentValue[0] = new Date(currentValue[0]);
  //               return currentValue;
  //             }
  //             else {
  //               return currentValue;
  //             }
  //           });
  //           let data: any = google.visualization.arrayToDataTable(newArray);
  //           let options = {
  //             chart: { trendlines: { 0: { color: 'black' }, 1: { color: 'yellow' }, 2: { color: 'brown' } } },
  //             displayAnnotations: true,
  //             displayZoomButtons: false,
  //             allValuesSuffix: '°C'
  //           }
  //           var chart = new google.visualization.AnnotationChart(document.getElementById('sensortemp_div'));
  //           chart.draw(data, options);

  //         }
  //         //if (response.body.frequency.length > this.lineChartLabelsTemp.length && _satus === "interval") {
  //         //  this.lineChartDataTemp = response.body.chartdata;
  //         //  this.lineChartLabelsTemp = response.body.frequency;
  //         //}
  //         //else if (_satus !== "interval") {
  //         //  this.lineChartDataTemp = response.body.chartdata;
  //         //  this.lineChartLabelsTemp = response.body.frequency;
  //         //}
  //         //// tslint:disable-next-line: prefer-for-of
  //         //for (let i = 0; i < response.body.chartdata.length; i++) {
  //         //  const maxVal = response.body.chartdata[i].data.reduce((a, b) => Math.max(a, b));
  //         //  sensorTempMaxVals.push(maxVal);
  //         //}
  //         //this.lineChartOptionsTemp.annotation.annotations[0].yMin = thresholdVals[1];
  //         //this.lineChartOptionsTemp.annotation.annotations[0].yMax = thresholdVals[2];

  //         //this.lineChartOptionsTemp.annotation.annotations[1].yMin = thresholdVals[0];
  //         //this.lineChartOptionsTemp.annotation.annotations[1].yMax = thresholdVals[1];

  //         //this.lineChartOptionsTemp.annotation.annotations[2].yMin = 0;
  //         //this.lineChartOptionsTemp.annotation.annotations[2].yMax = thresholdVals[0];

  //         //// tslint:disable-next-line: variable-name
  //         //const _maxVal = sensorTempMaxVals.reduce((a, b) => Math.max(a, b));

  //         //this.lineChartOptionsTemp.scales.yAxes[0].ticks.max = Math.max(_maxVal, thresholdVals[2]);
  //         //this.lineChartOptionsTemp.annotation.annotations[0].yMax = Math.max(_maxVal, thresholdVals[2]);


  //       }
  //     }
  //   });
  // }

  // async getSensorOrientationCharts(_satus) {
  //   const sensorOrMaxVals1 = [];
  //   const sensorOrMinVals1 = [];
  //   if (_satus !== "interval") {
  //     this.showlineChart3 = false;
  //   }
  //   let response: any;
  //   const body = {
  //     deviceid: this.deviceId,
  //     assetid: parseInt(this.assetId),
  //     sensorinterval: this.selectValue === null ? 24 : this.selectValue,
  //     sensordetailtype: this.valueType,
  //     sensorids: [25, 26, 27],
  //     // tslint:disable-next-line: radix
  //     //datafrequency: parseInt(localStorage.getItem('dataFrq'))
  //   };
  //   this.service.postData(this.accelsensorData, body).then(res => {
  //     //this.showlineChart3 = true;
  //     this.chartBoxVisibility1 = true;
  //     response = JSON.parse(JSON.stringify(res)).data;
  //     if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
  //       const msgErr = response.body.message;
  //       this.service.showError(msgErr);
  //     } else if (response.status === 'success') {
  //       if (response.body.message === 'No results found') {
  //         this.showlineChart3 = false;
  //       } else {
  //         let thresholdVals = [];
  //         thresholdVals = response.body.threshold;
  //         const orArrVal = [];
  //         if (response.body.chartdata !== 0) {
  //           this.showlineChart3 = true;
  //           let newArray = response.body.chartdata.map((currentValue) => {
  //             if (currentValue[0] !== "time") {
  //               currentValue[0] = new Date(currentValue[0]);
  //               return currentValue;
  //             }
  //             else {
  //               return currentValue;
  //             }
  //           });

  //           let data: any = google.visualization.arrayToDataTable(newArray);
  //           let options = {
  //             chart: { trendlines: { 0: { color: 'black' }, 1: { color: 'yellow' }, 2: { color: 'brown' } }},
  //             displayAnnotations: true,
  //             displayZoomButtons: false,
  //             allValuesSuffix: '°'
  //           }
  //           var chart = new google.visualization.AnnotationChart(document.getElementById('orientation_div'));
  //           chart.draw(data, options);



  //           // tslint:disable-next-line: prefer-for-of
  //           //for (let dataMe1 = 0; dataMe1 < response.body.chartdata.length; dataMe1++) {
  //           //  if (response.body.chartdata[dataMe1].label === 'Rate of change of Orientation X') {
  //           //    orArrVal.splice(0, 0, response.body.chartdata[dataMe1]);
  //           //  } else
  //           //    if (response.body.chartdata[dataMe1].label === 'Rate of change of Orientation Y') {
  //           //      orArrVal.splice(1, 0, response.body.chartdata[dataMe1]);
  //           //    } else
  //           //      if (response.body.chartdata[dataMe1].label === 'Rate of change of Orientation Z') {
  //           //        orArrVal.splice(2, 0, response.body.chartdata[dataMe1]);
  //           //      }
  //           //}
  //           //const arrValueOrientation = orArrVal;
  //           //for (var i = 0; i < arrValueOrientation.length; i++) {
  //           //  if (arrValueOrientation[i].label === 'Rate of change of Orientation X') {
  //           //    arrValueOrientation[i].label = 'Orientation X';
  //           //  }
  //           //  if (arrValueOrientation[i].label === 'Rate of change of Orientation Y') {
  //           //    arrValueOrientation[i].label = 'Orientation Y';
  //           //  }
  //           //  if (arrValueOrientation[i].label === 'Rate of change of Orientation Z') {
  //           //    arrValueOrientation[i].label = 'Orientation Z';
  //           //  }
  //           //}
  //           //if (response.body.frequency.length > this.lineChartLabelsOrientation.length && _satus === "interval") {
  //           //  this.lineChartDataOrientation = arrValueOrientation;
  //           //  this.lineChartLabelsOrientation = response.body.frequency;
  //           //}
  //           //else if (_satus !== "interval") {
  //           //  this.lineChartDataOrientation = arrValueOrientation;
  //           //  this.lineChartLabelsOrientation = response.body.frequency;
  //           //}
  //         }

  //         // tslint:disable-next-line: prefer-for-of
  //         //for (let i = 0; i < response.body.chartdata.length; i++) {
  //         //  const maxVal = response.body.chartdata[i].data.reduce((a, b) => Math.max(a, b));
  //         //  sensorOrMaxVals1.push(maxVal);
  //         //}
  //         //// tslint:disable-next-line: variable-name


  //         //for (let i = 0; i < response.body.chartdata.length; i++) {
  //         //  const minVal = response.body.chartdata[i].data.reduce((a, b) => Math.min(a, b));
  //         //  sensorOrMinVals1.push(minVal);
  //         //}
  //         //// tslint:disable-next-line: variable-name
  //         //this.lineChartOptionsOrientation.annotation.annotations[0].yMin = thresholdVals[1];
  //         //this.lineChartOptionsOrientation.annotation.annotations[0].yMax = thresholdVals[2];

  //         //this.lineChartOptionsOrientation.annotation.annotations[1].yMin = thresholdVals[0];
  //         //this.lineChartOptionsOrientation.annotation.annotations[1].yMax = thresholdVals[1];

  //         //this.lineChartOptionsOrientation.annotation.annotations[2].yMin = 0;
  //         //this.lineChartOptionsOrientation.annotation.annotations[2].yMax = thresholdVals[0];

  //         //const _maxVal = sensorOrMaxVals1.reduce((a, b) => Math.max(a, b));
  //         //this.lineChartOptionsOrientation.scales.yAxes[0].ticks.max = Math.max(_maxVal, thresholdVals[2]);
  //         //this.lineChartOptionsOrientation.annotation.annotations[0].yMax = Math.max(_maxVal, thresholdVals[2]);
  //         //const _minVal = sensorOrMinVals1.reduce((a, b) => Math.min(a, b));
  //         //this.lineChartOptionsOrientation.scales.yAxes[0].ticks.min = Math.min(_minVal, 0);
  //         //this.lineChartOptionsOrientation.annotation.annotations[2].yMin = Math.min(_minVal, 0);


  //       }
  //     }
  //   });
  // }

  // async openDeepDetail() {
  //   const navigationExtras = {
  //     skipLocationChange: true,
  //     queryParams: {
  //       nameDevice: this.nameDevice,
  //       errorStatus: this.errorStatus,
  //       deviceStatus: this.deviceStatus,
  //       deviceID: this.deviceId,
  //       assetid: this.assetId,
  //       onOffStatus: this._status,
  //       deviceCurrentStatus: this._devStaus,
  //       sinceDate: this._offlineStatus,
  //       lastUpdate: this._lastUpdate
  //     }
  //   };
  //   this.router.navigate(['deep-link-detail/'], navigationExtras);
  // }
}
